import { createReducer, on } from '@ngrx/store';
import {
  CreatedSubcategoryEvent,
  GotAllSubcategoriesEvent,
  UpdatedSubcategoryEvent,
  UpdatedStateSubcategoryEvent,
} from './subcategory.events';
import { SubcategoryState } from './subcategory.state';

export const subcategoryKey = 'subcategory';
export const initialState: SubcategoryState = {
  entities: {},
  byQuery: {},
};

export const SubcategoryReducer = createReducer(
  initialState,
  on(GotAllSubcategoriesEvent, (state, { entities }) => ({
    ...state,
    entities: entities.reduce((acc, entity) => ({ ...acc, [entity.id]: entity }), {}),
  })),
  on(CreatedSubcategoryEvent, (state, action: any) => {
    const entity = action.entity || (action.entities && action.entities[0]);
    if (!entity) return state;
    return {
      ...state,
      entities: { ...state.entities, [entity.id]: { ...entity } },
    };
  }),
  on(UpdatedSubcategoryEvent, (state, action: any) => {
    const entity = action.entity || (action.entities && action.entities[0]);
    if (!entity) return state;
    const updatedEntity = { ...entity, updatedAt: Date.now() };
    return {
      ...state,
      entities: { ...state.entities, [entity.id]: updatedEntity },
    };
  }),
  on(UpdatedStateSubcategoryEvent, (state, action: any) => {
    const entity = action.entity || (action.entities && action.entities[0]);
    if (!entity) return state;
    return {
      ...state,
      entities: { ...state.entities, [entity.id]: { ...entity } },
    };
  }),
);
